import ApiService from '@/services/apiService';
import { mapState, mapGetters } from 'vuex';
import uniqBy from 'lodash/uniqBy';
export default {
  name: 'CoreTenantBridgeErrors',
  props: {},
  data: function () {
    return {
      errorBridges: []
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme']),
    ...mapGetters({
      sessionPrimaryTenantIds: 'authentication/primaryTenantIds',
      sessionUserId: 'authentication/userId'
    })
  },
  mounted() {
    this.loadTenants();
  },
  methods: {
    loadTenants() {
      return Promise.all(this.$store.state.app.permissions['all.manage.tenantIds'].map(tenantId => {
        return ApiService.getBridgesWithErrorsForTenantHierarchy(tenantId);
      })).then(errorBridges => {
        this.errorBridges = errorBridges.reduce((errorBridges, bridges) => {
          return errorBridges.concat(bridges);
        }, []);

        // it may be possible that the tenantids are overlapping, so the same bridge may be requested multiple times
        this.errorBridges = uniqBy(this.errorBridges, bridge => bridge.id);
      }).catch(err => {
        // does the user need to be informed here? offer a "reload" button to trigger loading the bridges again?
        console.error('Could not retrieve error tenant-bridges', err);
      });

      // return Promise.all(
      //   this.sessionPrimaryTenantIds.map((tenantId) => {
      //     return ApiService.tenantGetById(tenantId, ['no-scope-descendents']);
      //   })
      // )
      //   .then((tenants) => {
      //     const extractAllTenants = (tenant) => {
      //       if (get(tenant, 'children', []).length === 0) {
      //         return [tenant];
      //       }
      //       return tenant.children.reduce(
      //         (tenants, subTenant) => {
      //           return tenants.concat(extractAllTenants(subTenant));
      //         },
      //         [tenant]
      //       );
      //     };
      //     const allTenants = extractAllTenants({ children: tenants }).filter((t) => !!t && !!t.id);
      //     return Promise.all(
      //       allTenants.map((tenant) => {
      //         return ApiService.getBridgesForTenant(tenant.id).then((bridges) => {
      //           return bridges
      //             .map((bridge) => {
      //               if (bridge.state === 'error') {
      //                 return { ...bridge, tenantName: tenant.name };
      //               }
      //               return null;
      //             })
      //             .filter((b) => !!b);
      //         });
      //       })
      //     );
      //   })
      //   .then((tenantBridges) => {
      //     this.errorBridges = tenantBridges.reduce((errorBridges, bridges) => {
      //       return errorBridges.concat(bridges);
      //     }, []);
      //   })
      //   .catch((err) => {
      //     // does the user need to be informed here? offer a "reload" button to trigger loading the bridges again?
      //     console.error('Could not retrieve all tenant-bridges', err);
      //   });
    }
  }
};